module.exports = __webpack_public_path__ + "img/icons_22.f560bf13.svg";